<template>
    <section />
</template>

<script>
export default {
    name: 'ui-filter',
    props: {
        method: {
            type: String,
            required: true,
            default: ''
        },
        filters: {
            type: Object,
            required: true,
            default: () => {}
        },
		index: {
			type: Number,
			required: true,
			default: null
		}
    },

    mounted() {
        this.$root.$on(`select-v2-open-event-${this.method}`, () => {
			this.$emit('clicked', this.filters.name, this.index)

			let filter = this.filters

			if (filter && !filter.requestOnStart && !filter.alreadyRequested) {
				(() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
					const api = service.default.build()
					let params = ['']

					if (filter.serviceParams) params = [...filter.serviceParams]

					filter.loading = true

					api[filter.method](...params).then(response => {
						let data = []
						/** Verifica se a requisição retornou uma paginação */
						// eslint-disable-next-line no-prototype-builtins
						if (response.data.hasOwnProperty('total')) {
							data = [...response.data.data]

						/** Verifica se a requisição retornou um array */
						// eslint-disable-next-line no-prototype-builtins
						} else if (response.data.hasOwnProperty('length')) {
							data = [...response.data]

						/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
						} else if (typeof response.data === 'object') {
							data = { ...response.data }
						}

						/** Verifica se os resultados necessitam ser formatados */
						if (filter.parse) {
							filter.options = filter.parse(data)
						} else {
							filter.options = Object.values(data)
						}

						filter.loading = false
					}).catch(() => {
						filter.loading = false
					})

					filter.alreadyRequested = true
				}).catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
				})
			}
		})
    },

}
</script>

<style>

</style>
